"use client";
import "swiper/css";
import "swiper/css/navigation";
import { fetchNews } from "../lib/newApi";
import Spinner from "../ui/Spinner";
import Link from "next/link";
import dynamic from "next/dynamic";
import { useQuery } from "@tanstack/react-query";
const SwiperFrame = dynamic(() => import("@/app/ui/SwiperFrame"), {
  ssr: true,
});

export default function NewsSwiper({ isMerchant }) {
  const platform = isMerchant ? 4 : 5;
  // const [isClient, setIsClient] = useState(false);
  // const [news, setNews] = useState([]);

  // useEffect(() => {
  //   setIsClient(true);
  //   const params = { platform, page: 1 };
  //   fetchNews(params).then((data) => setNews(data));
  // }, [platform]);
  // if (!isClient) return <Spinner />;

  const { data: news, isLoading } = useQuery({
    queryKey: ["news", platform],
    queryFn: async () => {
      const params = { platform, page: 1 };
      const res = await fetchNews(params);
      return res.data;
    },
  });
  if (isLoading) return <Spinner />;

  return (
    <div className="latest-news-container">
      <SwiperFrame latestNews={news} />
      <div className="grid justify-center ">
        {Array.isArray(news?.list) && news?.list.length >= 1 && (
          <Link
            href={isMerchant ? "/merchant/news" : "/news"}
            onClick={() => window.scrollTo(0, 0)}
          >
            <span className="button">更多消息</span>
          </Link>
        )}
      </div>
    </div>
  );
}
